import Api from '@/api/clinique/_clinique.js'

export default {
    getListeOrdonnancePatientByListeOrdonnance(data) {
        const promise = Api().post('/ordonnances/patient/liste-ordonnance', data)
        return promise.then((response) => response.data)
    },
}